/**
 * Created by shlee on 2018-08-08
 * Axios 를 이용한 http module
 */
import Axios from 'axios';
import store from '../store'
import * as types from '../store/mutation-types'

// 기본 설정값
export const constants = {
    // milliseconds
    defaultTimeout: 10000,
    contentType: {
        application_form_urlencoded: 'application/x-www-form-urlencoded',
        application_json: 'application/json',
        application_mutipart_form: 'multipart/form-data',
    }
}

export const defaultAxios = function(contentType, ctrProgress) {
    let accessToken = store.getters['userAccount/accessToken'];
    let axios = Axios.create({
        baseURL: process.env.API_BASE_URL,//'http://localhost:8081/',
        timeout : constants.defaultTimeout,
        headers : {'accessToken' : accessToken, 'Content-type': contentType},
        withCredentials : false
    });
    if(ctrProgress == false) {
        axios.interceptors.request.use(
            conf => {
                store.commit('common/' + types.Common.SPINNER_STATE, true);
                return Promise.resolve(conf);
            },
            error => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            response => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return Promise.resolve(response);
            },
            error => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return Promise.reject(error);
                // return error;
            }
        );
    }

    return axios;
}

export const kakaoRestAPI = function(contentType, ctrProgress) {
    let accessToken = process.env.KAKAO_API_TOKEN;

    let axios = Axios.create({
        baseURL: process.env.KAKAO_HOST,//'https://dapi.kakao.com/',
        timeout : constants.defaultTimeout,
        headers : {'Authorization' : accessToken, 'Content-type': contentType},
        withCredentials : false
    });
    if(ctrProgress == false) {
        axios.interceptors.request.use(
            conf => {
                store.commit('common/' + types.Common.SPINNER_STATE, true);
                return conf;
            },
            error => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            response => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return response;
            },
            error => {
                store.commit('common/' + types.Common.SPINNER_STATE, false);
                return Promise.reject(error);
            }
        );
    }
    return axios;
}


// WEBPACK FOOTER //
// ./src/data/httpWithAxios.js